export enum LOCALE {
  en = 'en',
}
